module.exports = __webpack_public_path__ + "static/media/antigua-historic-14.0b3517ef.jpg";